import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { PostsLaunchQuestions } from '../releases/plan/rollout/launch/PostsLaunchQuestions';
import type { CalendarLaunch } from './useCalendarLaunch';

interface CalendarLaunchDialogsProps {
  accountId: number;
  launch: CalendarLaunch;
}

/**
 * The one question of "Schedule all drafts of this day": the launch questions of the plan ("Before
 * we schedule: 2 quick answers"), asked one time for the drafts of the day, only when a platform
 * needs the user. With no question the drafts are scheduled at once, as in the plan (owner
 * decision 2026-10-11); the units show under the button.
 */
const CalendarLaunchDialogsComponent: React.FC<CalendarLaunchDialogsProps> = ({ accountId, launch }) => {
  const intl = useIntl();
  return (
    <PostsLaunchQuestions
      accountId={accountId}
      pending={launch.pending}
      description={intl.formatMessage({
        id: 'app.sml.promote.calendar.scheduleAll.questionsBody',
        defaultMessage: 'We ask one time for the drafts of this day. Your answer goes on every post of the channel.',
      })}
      isBusy={launch.isBusy}
      error={launch.error}
      onAnswer={launch.answer}
      onCancel={launch.cancel}
    />
  );
};

export const CalendarLaunchDialogs = TypedMemo(CalendarLaunchDialogsComponent);
